// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__ScgNE","section-1":"styles_section-1__xzC-P","content":"styles_content__LQ6w3","section-2":"styles_section-2__GeXwI"};